export default __webpack_public_path__ + "static/media/downArrow.aa595407.svg";